export function AutoUnsubscribe(skip: string[] = []): Function {
    return constructor => {
        const original = constructor.prototype.ngOnDestroy;

        constructor.prototype.ngOnDestroy = function (): void {
            Object.keys(this).forEach(key => {
                if (!skip.includes(key)) {
                    const property = this[key];

                    if (property && (typeof property.unsubscribe === 'function')) {
                        property.unsubscribe();
                    }
                }
            });

            if (original && typeof original === 'function') {
                original.apply(this, arguments);
            }
        };
    };
}
